import { Tool } from '../../types';

export const developmentTools: Tool[] = [
  {
    id: 'github',
    name: 'GitHub',
    category: 'Version Control',  // Changed from "Development" to be more specific
    description: 'Version control and collaboration platform for developers',
    pricing: ['free', 'medium'],
    features: ['integrations', 'security', 'scalability'],
    bestFor: ['startup'],
    compatibleWith: ['saas', 'mobile-app', 'desktop-software'],
    notSuitableFor: ['e-commerce', 'retail', 'service-business', 'consulting-firm'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['technology'],
    website: 'https://github.com',
    imageUrl: 'https://logo.clearbit.com/github.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'solo'
  },
  {
    id: 'gitlab',
    name: 'GitLab',
    category: 'DevOps',  // Changed from "Development" to be more specific
    description: 'Complete DevOps platform with Git repository management',
    pricing: ['free', 'medium', 'high'],
    features: ['automation', 'integrations', 'security', 'scalability'],
    bestFor: ['startup'],
    compatibleWith: ['saas', 'mobile-app', 'desktop-software'],
    notSuitableFor: ['e-commerce', 'retail', 'service-business', 'consulting-firm'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['technology'],
    website: 'https://gitlab.com',
    imageUrl: 'https://logo.clearbit.com/gitlab.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'solo'
  },
  {
    id: 'vs-code',
    name: 'Visual Studio Code',
    category: 'Engineering',  // Changed from "Development" to be more specific
    description: 'Powerful and extensible code editor',
    pricing: ['free'],
    features: ['ease-of-use', 'integrations', 'scalability'],
    bestFor: ['startup'],
    compatibleWith: ['saas', 'mobile-app', 'desktop-software'],
    notSuitableFor: ['e-commerce', 'retail', 'service-business', 'consulting-firm'],
    goals: ['streamline-operations'],
    industries: ['technology'],
    website: 'https://code.visualstudio.com',
    imageUrl: 'https://logo.clearbit.com/microsoft.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'solo'
  }
];